import { render } from "./AppointmentDialog.vue?vue&type=template&id=4fac4641&scoped=true&ts=true"
import script from "./AppointmentDialog.vue?vue&type=script&lang=ts"
export * from "./AppointmentDialog.vue?vue&type=script&lang=ts"

import "./AppointmentDialog.vue?vue&type=style&index=0&id=4fac4641&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fac4641"]])

export default __exports__